
import { tr } from '../translate'
import ExternalLink from '@/assets/icons/support_ticket/external-link.svg?inline'
import School from '@/assets/icons/support_ticket/school.svg?inline'

export default {
  components: { ExternalLink, School },
  props: {
    config: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ui() {
      return this.config?.ui
    },
  },
  methods: {
    tr(entry) {
      return tr(entry, this.$i18n.locale)
    },
  },
}
